import React from 'react';
import {
    Dialog,
    DialogTitle,
    Grid,
    Button,
    DialogContent,
} from '@material-ui/core';

const VerifyDialog = (props) => {
    return (
        <Dialog
            open={props.open}
            onClose={() => {
                props.setOpen(false);
            }}
            style={{ padding: 10 }}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Button
                            variant='contained'
                            color='primary'
                            fullWidth
                            onClick={props.action}
                        >
                            Ja
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => {
                                props.setOpen(false);
                            }}
                        >
                            Nei
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default VerifyDialog;
